import {Modal} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import Select from "react-select";
import {playlistService} from "../../../../services/playlistsService/playlistService";
import {MasterClassService} from "../../../../services/masterClassService/masterClassService";
import {toast} from "react-toastify";
import Button from "react-bootstrap/Button";
import AddPlaylistModal from "../../../playlists/modals/AddPlaylistModal";
import useDebounce from "../../../../hooks/useDebounce";

const AddToPlaylistModal = ({ onClose, masterClass, onMasterclassUpdate }) => {
    const [allPlaylists, setAllPlaylists] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const [selectedPlaylist, setSelectedPlaylist] = useState();
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [options, setOptions] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const debouncedSearchTerm = useDebounce(searchTerm, 750);

    const handleClose = () => {
        onClose();
    };

    const allPlaylistsData = () => {
        setIsLoading(true);
        playlistService.getPlaylists(null, searchTerm).then((response) => {
            setAllPlaylists(response?.data.data);
            setIsLoading(false);
        });
    };

    useEffect(() => {
        allPlaylistsData();
    }, []);

    useEffect(() => {
        allPlaylistsData(1, searchTerm);
    }, [debouncedSearchTerm]);

    useEffect(() => {
        setOptions([
            { value: 'favorites', label: 'Favorites' },
            ...allPlaylists.map((option) => ({
                value: option.id,
                label: option.name,
            })),
        ]);
    }, [allPlaylists]);

    const handleChange = (playlist) => {
        setSelectedPlaylist(playlist);
    };

    const handleSearch = (value) => {
        setSearchTerm(value);
    };

    const handleAddToPlaylist = async () => {
        if (!selectedPlaylist) {
            toast.error("Please select a playlist first.");
            return;
        }

        setIsAdding(true);
        try {
            let updatedMasterclass = null;
            // hardcode value, but "favorites" is system module, not dynamic playlist
            console.log(selectedPlaylist)
            if (selectedPlaylist.value === 'favorites') {
                updatedMasterclass = await MasterClassService.addToFavorite({master_class_id: masterClass?.id});
            } else {
                updatedMasterclass = await playlistService.addMasterClassToPlaylist(selectedPlaylist.value, masterClass?.id);
            }
            onMasterclassUpdate(updatedMasterclass.data);
            onClose();
            toast.success("Masterclass has been successfully added to playlist.");
        } catch (error) {
            toast.error(error?.response?.data?.message);
        } finally {
            setIsAdding(false);
        }
    };

    const handleCreatePlaylist = (playlist) => {
        options.push({
            value: playlist.id,
            label: playlist.name,
        });
    };

    const selectStyles = {
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
        menu: (base) => ({ ...base, zIndex: 9999 }),
    };

    return (
        <>
            <Modal
                show={true}
                onHide={handleClose}
                centered
                size="lg"
                scrollable
                dialogClassName="playlist-modal"
                contentClassName="playlist-modal__content"
                aria-labelledby="add-to-playlist-title"
            >
                <Modal.Header className="playlist-modal__header">
                    <h5 id="add-to-playlist-title" className="mb-0">
                        Add to Playlist
                    </h5>

                    <Button
                        variant="outline-primary"
                        className="playlist-modal__newbtn"
                        onClick={() => setShowCreateModal(true)}
                    >
                        New Playlist
                    </Button>
                </Modal.Header>

                <Modal.Body className="playlist-modal__body">
                    <label className="form-label mb-2">Select one of your playlists</label>
                    <Select
                        name="playlists"
                        isLoading={isLoading}
                        options={options}
                        onChange={handleChange}
                        placeholder="Start typing to search…"
                        classNamePrefix="rs"
                        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                        menuShouldScrollIntoView
                        maxMenuHeight={260}
                        styles={selectStyles}
                        isSearchable={true}
                        onInputChange={handleSearch}
                    />
                </Modal.Body>

                <Modal.Footer className="playlist-modal__footer">
                    <Button
                        variant="primary"
                        className="add-btn"
                        onClick={handleAddToPlaylist}
                        disabled={isAdding}
                    >
                        {isAdding ? "Adding…" : "Add to Playlist"}
                    </Button>
                </Modal.Footer>
            </Modal>

            {showCreateModal && (
                <AddPlaylistModal
                    onClose={() => setShowCreateModal(false)}
                    onCreated={handleCreatePlaylist}
                />
            )}
        </>
    );
};

export default AddToPlaylistModal;